var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.835 15L16.835 20C17.663 20.828 19.007 20.828 19.835 20V20C20.663 19.172 20.663 17.828 19.835 17L14.835 12",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9159 5.84718C20.9399 5.87018 20.9579 5.90018 20.9669 5.93218C21.4369 7.49918 21.0729 9.26218 19.8349 10.5002C18.5839 11.7512 16.7969 12.1092 15.2179 11.6172L6.87091 19.9642C6.05791 20.7772 4.73191 20.8382 3.89091 20.0542C3.00691 19.2312 2.98891 17.8472 3.83491 17.0002L12.2179 8.61718C11.7259 7.03818 12.0839 5.25118 13.3349 4.00018C14.5729 2.76218 16.3359 2.39818 17.9029 2.86818C17.9349 2.87818 17.9649 2.89518 17.9879 2.91918L18.1499 3.08118C18.2279 3.15918 18.2279 3.28618 18.1499 3.36418L15.5149 6.00018L17.8349 8.32018L20.4709 5.68418C20.5489 5.60618 20.6759 5.60618 20.7539 5.68418L20.9159 5.84718V5.84718Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93292 4.29296L3.60692 6.31596C3.74292 6.72496 4.12492 6.99996 4.55592 6.99996H6.83492V4.72096C6.83492 4.29096 6.55992 3.90796 6.15092 3.77196L4.12792 3.09796C3.94792 3.03796 3.74992 3.08496 3.61592 3.21896L3.05392 3.78096C2.91992 3.91496 2.87292 4.11296 2.93292 4.29296V4.29296Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 7L10.3398 10.5",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIcon);
export default __webpack_public_path__ + "static/media/toolsIcon.b4a3f5e2eb4451335948968cdcfa5c5b.svg";
export { ForwardRef as ReactComponent };